import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

const searchURI = 'https://yearbook.unoda.org'

function _reduceFacets(facets) {
    let acc = '';
    Object.entries(facets).forEach((key, value) => {
        acc += '&'+key[0]+'='+key[1];
    });
    return acc;
}

function _reduceSearchFields(queryFields, searchTerm) {
    let acc = '';
    queryFields.forEach((field) => {
        acc += '&'+field+'='+searchTerm;
    });
    return acc;
}

export const yearbookSearchApi = createApi({
    reducerPath: 'yearbookSearchApi',
    baseQuery: fetchBaseQuery({baseUrl: `${searchURI}/api/v2/yearbook_pages/`}),
    endpoints: builder => ({
        getYearbooks: builder.query({
            query: (data) => {
                const {page, perPage, facets, queryFields, searchTerm, exactSearch} = data;
                const facetString = _reduceFacets(facets)
                const searchFieldString = _reduceSearchFields(queryFields, searchTerm)
                console.log(searchFieldString)
                return `?page=${page}&exact_search=${exactSearch}&size=${perPage}&lang_code=en-us${searchFieldString}${facetString}`;
            },
        }),
    })
});

export const { useGetYearbooksQuery } = yearbookSearchApi;
